import { API_BASE_URL } from '../client';

export const CALENDAR_ENDPOINTS = {
  CALENDAR: {
    LIST: `${API_BASE_URL}/Calendar`,
    INIT: `${API_BASE_URL}/Calendar/init`,
    UPDATE: (id: number) => `${API_BASE_URL}/Calendar/${id}`,
  },
} as const;
